import styled from 'styled-components';

export const Legend = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 190px;
  gap: 32px;
  margin-bottom: 16px;

  h4 {
    color: #515151;
    text-transform: uppercase;
  }
`;

export const GroupCard = styled(Legend)`
  padding: 24px 0;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  margin-left: 16px;
  margin-right: 16px;

  .title {
    padding-left: 24px;
  }
`;
